/**
 * useAuth Hook
 * 
 * Provides access to authentication context throughout the application.
 * Must be used within an AuthProvider.
 */

import { useContext } from 'react';
import { AuthContext, type AuthContextType } from '../context/AuthContext';

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
